import axios from 'utils/axios';

export const getServicePackagesMyInfo = (id: string) => {
  return id.startsWith("sp") ?
    axios.get(`/api/v1/servicepackages/my/sp_info/${id}`) :
    axios.get(`/api/v1/servicepackages/my/${id}`)
};
